'use client';

import { CSSProperties, ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import { RegionSelector } from 'components/shared/RegionSelector';
import styles from './Layout.module.css';

export const Layout = ({
  className,
  children,
  baseImage,
  mobileBaseImage,
}: {
  className?: string;
  children: ReactNode;
  baseImage?: string;
  /** Shown below 768px. Desktop keeps `baseImage`. */
  mobileBaseImage?: string;
}) => {
  const t = useTranslations('common');

  const handleContact = () => {
    if (window && document != undefined) {
      window.open(`mailto:support@ultrahuman.com?`, '_blank');
    }
  };

  const desktopImage = getCompressedAssetUrl(
    baseImage || '/bios/complete-order/desktop.png',
  );
  const heroStyle: CSSProperties = mobileBaseImage
    ? ({
        '--claim-hero-mobile': `url(${getCompressedAssetUrl(mobileBaseImage)})`,
        '--claim-hero-desktop': `url(${desktopImage})`,
      } as CSSProperties)
    : { backgroundImage: `url(${desktopImage})` };

  return (
    <div className={className ? `${styles.root} ${className}` : styles.root}>
      <div
        className={
          mobileBaseImage ? `${styles.img} ${styles.imgResponsive}` : styles.img
        }
        style={heroStyle}
      />
      <div className={styles.content}>{children}</div>
      <div className={styles.footer}>
        <div className={styles['footer-content']}>
          <p>
            {t('form.support.anyIssues')}{' '}
            <button onClick={handleContact}>
              {t('form.support.emailSupport')}
            </button>{' '}
            {t('form.support.atEmail')}
          </p>
        </div>
        <div className={styles['language-selector-wrapper']}>
          <RegionSelector />
        </div>
      </div>
    </div>
  );
};
